(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["free-shipping-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('million-shipping-progress')) {
  customElements.define('million-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      document.addEventListener('cart:change', event => {
        const cart = event.detail?.cart;
        if (cart && Number.isFinite(cart.total_price)) this.updateShipping(cart.total_price);
      }, {signal: this.abortController.signal});
      this.updateShipping(Number(this.dataset.total));
    }
    disconnectedCallback() { this.abortController?.abort(); }
    updateShipping(total) {
      const threshold = Number(this.dataset.threshold);
      if (!Number.isFinite(total) || !Number.isFinite(threshold) || threshold <= 0) return;
      const reached = total >= threshold;
      const formatter = new Intl.NumberFormat(this.dataset.locale || 'nl-NL', {style: 'currency', currency: this.dataset.currency || 'EUR'});
      const amount = formatter.format(Math.max(0, threshold - total) / 100);
      const fee = formatter.format(Number(total >= 10000 ? this.dataset.reducedFee : this.dataset.baseFee) / 100);
      this.querySelector('[data-shipping-status]').textContent = reached ? this.dataset.reached : this.dataset.pending.replace('__AMOUNT__', amount);
      this.querySelector('[data-shipping-fee]').textContent = reached ? this.dataset.free : this.dataset.fee.replace('__AMOUNT__', fee);
      this.querySelector('progress').value = Math.max(0, Math.min(total, threshold));
      this.dataset.reachedState = String(reached);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["million-card-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('million-card-gallery')) {
  customElements.define('million-card-gallery', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
      this.next = this.querySelector('[data-gallery-next]');
      this.index = 0;
      if (!this.track || this.slides.length < 2) return;
      this.dataset.ready = 'true';
      this.next.hidden = false;
      this.next.addEventListener('click', () => this.goTo((this.index + 1) % this.slides.length), options);
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.goTo((this.index + (event.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length);
        this.slides[this.index].focus({preventScroll: true});
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, {...options, passive:true});
      this.track.addEventListener('pointerdown', event => {
        this.start = {x:event.clientX, y:event.clientY, scroll:this.track.scrollLeft, pointer:event.pointerId, mouse:event.pointerType === 'mouse'};
        this.dragged = false;
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.start) return;
        const dx = event.clientX - this.start.x;
        const dy = event.clientY - this.start.y;
        if (Math.abs(dx) > 8 || Math.abs(dy) > 8) this.dragged = true;
        if (this.start.mouse && this.dragged && Math.abs(dx) > Math.abs(dy)) {
          this.track.setPointerCapture(event.pointerId);
          this.track.style.scrollSnapType = 'none';
          this.track.scrollLeft = this.start.scroll - dx;
          event.preventDefault();
        }
      }, options);
      const finish = event => {
        if (this.start?.mouse && this.dragged) {
          this.track.style.scrollSnapType = '';
          this.goTo(Math.round(this.track.scrollLeft / this.track.clientWidth));
        }
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.start = null;
      };
      this.track.addEventListener('pointerup', finish, options);
      this.track.addEventListener('pointercancel', finish, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('click', event => {
        if (this.dragged) {event.preventDefault(); event.stopPropagation();}
      }, {...options, capture:true});
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {this.hydrate(1); this.observer.disconnect();}
      }, {rootMargin:'200px'});
      this.observer.observe(this);
      this.resize = new ResizeObserver(() => {
        if (this.track.clientWidth) this.track.scrollLeft = this.index * this.track.clientWidth;
      });
      this.resize.observe(this.track);
    }
    hydrate(index) {
      const template = this.slides[index]?.querySelector('template');
      if (template) template.replaceWith(template.content.cloneNode(true));
    }
    goTo(index) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.hydrate(this.index);
      this.track.scrollTo({left:this.index * this.track.clientWidth, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      this.updateAccess();
    }
    sync() {
      if (!this.track.clientWidth) return;
      this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      [this.index - 1, this.index, this.index + 1].forEach(index => this.hydrate(index));
      this.updateAccess();
    }
    updateAccess() {
      this.querySelector('[data-gallery-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.slides.forEach((slide, index) => {
        slide.tabIndex = index === this.index ? 0 : -1;
        if (index === this.index) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["million-cart-matches"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('million-cart-matches'))customElements.define('million-cart-matches',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();this.addEventListener('change',event=>{if(event.target.matches('.mc-select')){const money=event.target.selectedOptions[0]?.dataset.money;if(money)event.target.closest('.mc-card').querySelector('.mc-price').textContent=money;event.target.closest('.mc-card').querySelector('.mc-error').textContent=''}},{signal:this.abort.signal});this.addEventListener('cart:error',event=>{const card=event.target.closest('.mc-card');if(card)card.querySelector('.mc-error').textContent=this.dataset.error},{signal:this.abort.signal})}
 disconnectedCallback(){this.abort?.abort()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["million-outfit-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('million-outfit-preview')) {
    customElements.define('million-outfit-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        this.hoodie = this.querySelector('[data-outfit-size="hoodie"]');
        this.pants = this.querySelector('[data-outfit-size="pants"]');
        this.dialog = this.querySelector('dialog');
        this.money = new Intl.NumberFormat(this.dataset.locale || 'nl-NL', {style:'currency',currency:this.dataset.currency || 'EUR'});
        this.hoodie.addEventListener('change', () => this.update());
        this.pants.addEventListener('change', () => this.update());
        this.querySelector('[data-outfit-add]').addEventListener('click', () => {
          if (!this.hoodie.reportValidity() || !this.pants.reportValidity()) return;
          this.update();
          this.querySelector('[data-outfit-picked="hoodie"]').textContent = this.hoodie.selectedOptions[0].textContent.trim();
          this.querySelector('[data-outfit-picked="pants"]').textContent = this.pants.selectedOptions[0].textContent.trim();
          this.dialog.showModal();
        });
        this.querySelectorAll('[data-outfit-close]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.dialog.close(); } });
      }
      update() {
        const a=Number(this.hoodie.selectedOptions[0].dataset.price || this.hoodie.querySelector('[data-price]').dataset.price);
        const b=Number(this.pants.selectedOptions[0].dataset.price || this.pants.querySelector('[data-price]').dataset.price);
        const values={'[data-outfit-original]':a+b,'[data-outfit-total]':a+b-500,'[data-outfit-extra]':b-500,'[data-outfit-dialog-hoodie]':a,'[data-outfit-dialog-pants]':b,'[data-outfit-dialog-total]':a+b-500};
        for (const [selector,amount] of Object.entries(values)) this.querySelector(selector).textContent=this.money.format(amount/100);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["million-outfits"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('million-outfits'))customElements.define('million-outfits',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.active=0;this.money=new Intl.NumberFormat(document.documentElement.lang||'nl-NL',{style:'currency',currency:this.dataset.currency||'EUR'});this.querySelectorAll('.mo-item').forEach(item=>{const buttons=item.querySelectorAll('.mo-size');if(buttons.length===1)buttons[0].setAttribute('aria-pressed','true')});this.addEventListener('click',event=>{const size=event.target.closest('.mo-size');if(size){size.closest('.mo-item').querySelectorAll('.mo-size').forEach(b=>b.setAttribute('aria-pressed',String(b===size)));this.update()}const choice=event.target.closest('[data-select]');if(choice){this.active=Number(choice.dataset.select);this.querySelectorAll('[data-choice]').forEach(p=>p.hidden=Number(p.dataset.choice)!==this.active);this.querySelectorAll('[data-select]').forEach(p=>p.setAttribute('aria-pressed',String(p===choice)));this.querySelector('.mo-more').open=false;this.update();this.querySelector('.mo-partner [data-choice]:not([hidden]) .mo-size')?.focus({preventScroll:true})}if(event.target.closest('.mo-add'))this.addSet()});this.abort=new AbortController();document.addEventListener('variant:change',event=>{const id=String(event.detail?.variant?.id||'');this.syncMain(id)},{signal:this.abort.signal});this.syncMain(new URLSearchParams(location.search).get('variant'));this.update()}
 disconnectedCallback(){this.abort?.abort();this.ready=false}
 syncMain(id){if(!id)return;const main=this.querySelector('[data-role="main"]');const button=main?.querySelector('[data-variant="'+id+'"]');if(button){main.querySelectorAll('.mo-size').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.update()}}
 items(){return[this.querySelector('[data-role="main"]'),this.querySelector('[data-choice="'+this.active+'"] .mo-item')].filter(Boolean)}
 update(){const items=this.items();if(items.length!==2)return;const prices=items.map(item=>Number((item.querySelector('[aria-pressed="true"]')||item).dataset.price));const eligible=this.dataset.currency==='EUR'&&items.every((item,i)=>item.dataset.eligible==='true'&&prices[i]>=3995);items.forEach((item,i)=>item.querySelector('.mo-price').textContent=this.money.format(prices[i]/100));const total=prices.reduce((a,b)=>a+b,0);this.querySelector('[data-total]').textContent=this.money.format((total-(eligible?500:0))/100);this.querySelector('[data-old]').textContent=this.money.format(total/100);this.querySelector('[data-old]').hidden=!eligible;this.querySelector('.mo-badge').hidden=!eligible;this.querySelector('.mo-normal').hidden=eligible;this.querySelector('.mo-terms').hidden=!eligible;this.querySelector('.mo-status').textContent=''}
 async addSet(){if(this.busy)return;const items=this.items();const selected=items.map(item=>item.querySelector('.mo-size[aria-pressed="true"]'));if(selected.some(x=>!x)){this.querySelector('.mo-status').textContent=this.dataset.choose;items[selected.findIndex(x=>!x)].querySelector('.mo-size')?.focus({preventScroll:true});return}const button=this.querySelector('.mo-add'),label=button.textContent;this.busy=true;button.disabled=true;button.textContent=this.dataset.adding;try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:selected.map(v=>({id:v.dataset.variant,quantity:1}))})});if(!response.ok)throw new Error('cart');window.location.assign(this.dataset.cart)}catch(error){this.querySelector('.mo-status').textContent=this.dataset.error;this.querySelector('.mo-cart').hidden=false;button.disabled=false;button.textContent=label;this.busy=false}}
});
  } catch(e) { console.error(e); }
})();

})();
